import { DomainSessionId, DomainUserId } from '@hc-frontend/core-types';
import { z } from 'zod';

export const DomainIds = z.object({
  sessionId: DomainSessionId,
  userId: DomainUserId,
});

export type DomainIds = z.infer<typeof DomainIds>;
